import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import { useUser } from '../UserContext';

const SupporterMenu = ({ show, handleClose }) => {
  const [supporterIcon, setSupporterIcon] = useState('');
  const [supporterColor, setSupporterColor] = useState('');
  const { user, setUser } = useUser();

  useEffect(() => {
    if (user) {
    setSupporterIcon(user.supIcon);
    setSupporterColor(user.supColor);
    }
  }, []);

  const iconOptions = [
    "none", "woodenReno", "jaraxxus", "razorpetal", "bananas", "annoy-o-tron", "smorc", "tinyfin", "common", "rare", "epic", "legendary", "boombot", "horde", "alliance", "snake", "boomS", "chicken", "wowr", "finleySmile", "reno", "illidon", "bob", "cat", "shrugillL", "shrugillR", "voidw", "blingtron", "dhguy", "rainbow", "faelin", "skelehead", "treeh", "ghoul", "pensive", "trumpet", "scared", "frogface", "thumbsup", "clowno", "fintective", "rafaamPog", "finking", "shocked", "waveflipper", "treeLove", "qnikkoWhat", "qWOW", "qLOVE", "qCRY", "qCozy", "qCool", "qTPie", "qSleep", "starshine", "corncute", "snowflake", "gonk", "heartgem", "ghost", "pumpkin", "8murloc", "skelethead", "anger", "shARRk", "cheeseWink", "murComfy", "murComfyy", "murLaugh", "happyButtons", "lynessa", "gulpfingA"
    // ... add all other icon options here
  ];

  const colorOptions = [
    { id: '#565656', color: '#fff0' },
    { id: '#c33d3d', color: '#c33d3d' },
    { id: '#c33da3', color: '#c33da3' },
    { id: '#81368f', color: '#81368f' },
    { id: '#36558f', color: '#36558f' },
    { id: '#36838f', color: '#36838f' },
    { id: '#368f55', color: '#368f55' },
    { id: '#99508c', color: '#99508c' },
    { id: '#c96f00', color: '#c96f00' },
  ];

  const selectIcon = (icon) => {
    setSupporterIcon(icon);
    setUser(prevState => ({
        ...prevState,
        supIcon: icon
    }));    
    sendDataToServer(icon, supporterColor);
  };

  const selectColor = (color) => {
    setSupporterColor(color);
    setUser(prevState => ({
        ...prevState,
        supColor: color
    }));    
    sendDataToServer(supporterIcon, color);
  };

  const sendDataToServer = async (icon, color) => {
    try {
      const response = await axios.post('/api/users/update-supporter.php', {
        icon: icon,
        color: color
      });
      console.log('Data sent successfully:', response.data);
      // You might want to update the parent component or global state here
    } catch (error) {
      console.error('Error sending data:', error);
    }
  };

  if (!user || Number(user.rank) !== 1) {
    return null; // Don't render anything if user is not eligible
  }

  return (
        <div className="supporter-menu mt-3">
          <div className="selectors">
            <label htmlFor="iconOptions">Select User Icon:</label>
            <div id="iconOptions" className="icon-options d-flex flex-wrap">
              {iconOptions.map((icon) => (
                <img
                  key={icon}
                  className={`userIcon m-1 ${supporterIcon === icon ? 'badge-chosen' : ''}`}
                  alt={icon}
                  data-id={icon}
                  src={`/images/emotes/${icon}.png`}
                  srcSet={`/images/emotes/${icon}.png 1x, /images/emotes/${icon}2.png 2x, /images/emotes/${icon}3.png 4x`}
                  onClick={() => selectIcon(icon)}
                  style={{
                    width: '30px', border: supporterIcon === icon ? '3px solid #00f' : '3px solid #fff', // Highlight selected icon with border
                    cursor: 'pointer'
                  }}
                />
              ))}
            </div>

            <label htmlFor="colorSelector" className="mt-3">Select Name Color:</label>
            <div id="colorSelector" className="color-selector d-flex flex-wrap">
              {colorOptions.map((option) => (
                <div
                  key={option.id}
                  className={`color m-1 ${supporterColor === option.id ? 'color-chosen' : ''}`}
                  style={{
                    backgroundColor: option.color,
                    width: '30px',
                    height: '30px',
                    cursor: 'pointer',
                    border: supporterColor === option.id ? '3px solid #00f' : '3px solid #fff' // Highlight selected color with border
                  }}
                  onClick={() => selectColor(option.id)}
                />
              ))}
            </div>
          </div>
        </div>
  );
};

export default SupporterMenu;